import React from 'react';
import styled from 'styled-components';
import { THit, TOffer } from '@com/core/common/types/catalog';

type TProps = {
    product: THit | TOffer;
};

const CatalogTag = ({ product }: TProps): JSX.Element => {
    return (
        <Container className={product.catalog_tag_style === 'coupon' ? 'coupon' : ''}>
            <DiscountCode>{product.catalog_tag}</DiscountCode>
        </Container>
    );
};

const Container = styled.div`
    max-width: 100%;
    display: inline-flex;
    align-items: center;
    height: 22px;
    border: 1px solid;
    color: ${({ theme: { colors } }) => colors.brandSecondary};
    background-color: rgba(255, 255, 255, 0.9);
    padding: 0 6px;

    &.coupon {
        color: ${({ theme: { colors } }) => colors.generalPositive};
    }
`;

const DiscountCode = styled.p`
    flex: 1;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.714rem;
    font-weight: 600;
`;

export default CatalogTag;
